import { TenantInfoKey } from '@/lib/enum/statsig/tenantInfoKey';
import { getTenantLogoUrl } from '@/lib/tenantAssets';
import { useDynamicConfig } from '@statsig/react-bindings';
import Image from 'next/image';
import React from 'react'

const SignInLogo = () => {
  const config = useDynamicConfig("tenant_info");
  const tenantId = (config.get(TenantInfoKey.TenantId) as string) || "";

  return (
    <div className="h-16 w-40 relative">
      <Image src={getTenantLogoUrl(tenantId, "light") || ""} alt="Logo" fill />
    </div>
  )
}

export default SignInLogo;